import styled from 'styled-components';
import { List, spaceMixin } from '@zillow/constellation';

export const StyledList = styled(List)`
  min-width: ${spaceMixin(17)};
  margin: 0 auto;
  padding-left: ${spaceMixin(2)};
`;
